import { arrayBuilderPages } from 'platform/forms-system/src/js/patterns/array-builder';
import { whenAll, whenAny, whenNot } from 'platform/shared/health-apps';
import content from '../../../../locales/en/content.json';
import {
  includeTeraInformation,
  isShortFormEligible,
} from '../../../../utils/helpers';
import dischargePapersSummary, { attachmentsOptions } from './summary';
import dischargePapersUpload from './upload';

const renderPages = whenAny(
  whenNot(isShortFormEligible),
  whenAll(isShortFormEligible, includeTeraInformation),
);

export const dischargePapersPages = {
  ...arrayBuilderPages(attachmentsOptions, pageBuilder => ({
    dischargePapersSummary: pageBuilder.summaryPage({
      title: content['service-info--attachments-title'],
      path: 'military-service/documents',
      depends: renderPages,
      ...dischargePapersSummary,
    }),
    dischargePapersUpload: pageBuilder.itemPage({
      title: content['service-info--attachments-upload-title'],
      path: 'military-service-document-upload/:index',
      depends: renderPages,
      ...dischargePapersUpload,
    }),
  })),
};
